module.exports = __webpack_public_path__ + "static/johndigweed_3-4de15575c35756c7c9e8d4804f10495c.jpg";